import axios from 'axios';

// Get API gateway URL from environment
const API_GATEWAY_URL = (import.meta.env.VITE_API_GATEWAY_URL as string) || 'https://api.assayer-ai.com';

// Create axios instance with base configuration
export const apiClient = axios.create({
  baseURL: `${API_GATEWAY_URL}/assayer`,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
apiClient.interceptors.request.use(
  async (config) => {
    // Get Firebase auth token
    const auth = (await import('firebase/auth')).getAuth();
    const user = auth.currentUser;

    if (user) {
      const token = await user.getIdToken();
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Handle response errors
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Unauthorized - redirect to login
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);
